import React from "react";
import {
  motion,
  useScroll,
  useTransform,
  useSpring,
} from "framer-motion";
import "./Header.css";
import { useSectionScroll } from "../../hooks/useSectionScroll";

export const Header = ({ currentRef, nextRef, prevRef }) => {

  // Animações da logo com base no scroll
  const { scrollYProgress } = useScroll({
    target: currentRef,
    offset: ["start start", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, -100]);
  const opacity = useTransform(scrollYProgress, [0, 0.6], [1, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.7]);

  const smoothY = useSpring(y, { stiffness: 80, damping: 20 });
  const smoothOpacity = useSpring(opacity, { stiffness: 80, damping: 20 });
  const smoothScale = useSpring(scale, { stiffness: 80, damping: 20 });

  // Scroll automático suave para wheel e touch
  useSectionScroll({ currentRef, nextRef, prevRef });

  return (
    <div className="container" ref={currentRef}>
      <nav className="menu-redes-sociais">

        <a
          href="https://www.instagram.com/santacruzprefeitura"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <img
            src="/imagens/imagem-header/social-media/icons8-instagram-24.png"
            alt="Instagram"
            className="icons-header"
          />
        </a>

        {/* <a
          href="https://www.facebook.com/seu_perfil"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <img
            src="/imagens/imagem-header/social-media/icons8-facebook-24.png"
            alt="Facebook"
            className="icons-header"
          />
        </a>

        <a
          href="mailto:seu_email@exemplo.com"
          aria-label="Email"
        >
          <img
            src="/imagens/imagem-header/social-media/e-mail.png"
            alt="Email"
            className="icons-header"
          />
        </a> */}

        <a
          href="https://www.youtube.com/prefeiturasantacruzrn"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
        >
          <img
            src="/imagens/imagem-header/social-media/icons8-reproduzir-youtube-24.png"
            alt="YouTube"
            className="icons-header"
          />
        </a>
      </nav>

      <motion.div
        className="container-da-logo"
        style={{
          y: smoothY,
          opacity: smoothOpacity,
          scale: smoothScale,
        }}
      >
        <img
          src="../imagens/imagem-header/logo-maior-solicita.png"
          alt="Logo Solicita"
          className="logo-solicita"
        />
        <img
          src="../imagens/imagem-header/logo-solicita-mobile.png"
          alt="Logo Solicita Mobile"
          className="logo-solicita-mobile"
        />
      </motion.div>
    </div>
  );
};
